"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "pto-table" };
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<div class=\"pto-table-header\"><div class=\"pto-table-row\"><div class=\"pto-table-cell pto-day-text\"><span class=\"pto-table-item\">週労日数</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">0.5年</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">1.5年</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">2.5年</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">3.5年</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">4.5年</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">5.5年</span></div><div class=\"pto-table-cell\"><span class=\"pto-table-item pto-day-text\">6.5年以上</span></div></div></div>", 1);
const _hoisted_3 = { class: "pto-table-body" };
const _hoisted_4 = { class: "pto-table-cell pto-day-text" };
const _hoisted_5 = { class: "pto-table-item" };
const vue_3 = require("vue");
const PtoConfigRow_vue_1 = __importDefault(require("./PtoConfigRow.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'PtoConfigTable',
    props: {
        ptoConfigDays: {
            type: Object,
            required: true,
        }
    },
    emits: ["configParams"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const ptoConfigProp = (0, vue_3.computed)(() => {
            return props.ptoConfigDays;
        });
        const emit = __emit;
        function handleEmitPtoConfig(emitData) {
            emit("configParams", emitData);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(ptoConfigProp.value, (ptoConfigDay) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: ptoConfigDay.getNumIndicator(),
                            class: "pto-table-row"
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(ptoConfigDay.getNumIndicator()) + "日", 1 /* TEXT */),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("span", null, "以上", 512 /* NEED_PATCH */), [
                                    [vue_2.vShow, ptoConfigDay.getNumIndicator() >= 5]
                                ])
                            ]),
                            (0, vue_2.createVNode)(PtoConfigRow_vue_1.default, {
                                "pto-config-days": ptoConfigDay,
                                onConfigParams: handleEmitPtoConfig
                            }, null, 8 /* PROPS */, ["pto-config-days"])
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
